var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"task_approve"},[_c('v-layout',[_c('v-flex',{attrs:{"d-flex":"","align-center":"","justify-center":""}},[_c('span',[_vm._v("暂无任何审批")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }